import { localStorage } from 'dibs-browser-storage';
import { DESIGN_MANAGER_UPGRADE_SUBMITTED } from 'dibs-trade-design-manager/exports/tradeDesignManagerAuthHelpers';

export const DESIGN_MANAGER_UPGRADED = 'DESIGN_MANAGER_UPGRADED';

export function hasSubmittedDesignManagerUpgradeRequest() {
    return localStorage.getItem(DESIGN_MANAGER_UPGRADE_SUBMITTED);
}
